// Modifier B section questionnaire constants
export enum ModifierBQuestionnaireItem {
  MODIFIER_B_1_QUESTION = 'modifier-b/1/question',
  MODIFIER_B_1_NOTES = 'modifier-b/1/notes',
  MODIFIER_B_2_QUESTION = 'modifier-b/2/question',
  MODIFIER_B_2_NOTES = 'modifier-b/2/notes',
  MODIFIER_B_3_QUESTION = 'modifier-b/3/question',
  MODIFIER_B_3_NOTES = 'modifier-b/3/notes',
  MODIFIER_B_4_QUESTION = 'modifier-b/4/question',
  MODIFIER_B_4_NOTES = 'modifier-b/4/notes',
  MODIFIER_B_5_QUESTION = 'modifier-b/5/question',
  MODIFIER_B_5_NOTES = 'modifier-b/5/notes',
  MODIFIER_B_6_QUESTION = 'modifier-b/6/question',
  MODIFIER_B_6_NOTES = 'modifier-b/6/notes',
  MODIFIER_B_7_QUESTION = 'modifier-b/7/question',
  MODIFIER_B_7_NOTES = 'modifier-b/7/notes'
}
